import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import client, { endpoints } from '../api/client';

export default function ArticleDetail() {
  const { slug } = useParams();
  const { user } = useSelector((s) => s.auth);
  const navigate = useNavigate();
  const [a, setA] = useState(null);
  const [text, setText] = useState('');

  useEffect(() => { client.get(endpoints.articles.get(slug)).then(({ data }) => setA(data.article)).catch(() => setA(false)); }, [slug]);

  async function like() {
    if (!user) return navigate('/login');
    const { data } = await client.post(endpoints.articles.like(slug));
    setA({ ...a, liked: data.liked, likeCount: data.likeCount });
  }
  async function comment(e) {
    e.preventDefault();
    if (!user) return navigate('/login');
    const { data } = await client.post(endpoints.articles.comment(slug), { text });
    setA({ ...a, comments: [...a.comments, data.comment] }); setText('');
  }

  if (a === false) return <div className="container community"><h1>Article not found</h1><Link to="/articles">← All articles</Link></div>;
  if (!a) return <div className="container community"><p className="muted">Loading…</p></div>;

  return (
    <div className="container community narrow">
      {a.category && <span className="cat">{a.category}</span>}
      <h1>{a.title}</h1>
      <p className="muted">{a.author && <>By {a.author.name} · </>}{a.views} views</p>
      {a.coverImage && <img src={a.coverImage} alt="" className="article-cover" />}
      <div className="article-content" dangerouslySetInnerHTML={{ __html: a.bodyHtml }} />
      <div className="article-actions">
        <button className={`like ${a.liked ? 'liked' : ''}`} onClick={like}>{a.liked ? '♥' : '♡'} {a.likeCount}</button>
      </div>
      <div className="comments">
        <h3>{a.comments.length} {a.comments.length === 1 ? 'Comment' : 'Comments'}</h3>
        {a.comments.map((c, i) => <div key={i} className="comment"><strong>{c.author?.name}</strong><p>{c.text}</p></div>)}
        {user ? (
          <form onSubmit={comment} className="form">
            <textarea rows={3} value={text} onChange={(e) => setText(e.target.value)} placeholder="Add a comment…" />
            <button className="btn-primary" disabled={!text.trim()}>Comment</button>
          </form>
        ) : <p className="muted"><Link to="/login">Sign in</Link> to comment.</p>}
      </div>
      <p><Link to="/articles">← All articles</Link></p>
    </div>
  );
}
